<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1330px"
      unit="事务类别"
      edit-title
      id-key="RecordId"
     
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="事务标题" prop="InfoTitle">
              <el-input v-model="data.InfoTitle" placeholder="请输入事务标题" clearable></el-input>
            </el-form-item>
          </el-col>
         
          <el-col :span="isMB?24:12">
            <el-form-item label="办理周期" prop="InfoSource">
              <el-input v-model="data.InfoSource" placeholder="请输入办理周期" clearable></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="isMB?24:12">
            <el-form-item label="办理费用" prop="InfoSource">
              <el-input v-model="data.InfoSource" placeholder="请输入办理费用" clearable></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-form-item :label="isMB?'':'办理事项'" :label-width="isMB?'0':''" prop="InfoContent">
              <el-divider v-if="isMB">办理事项</el-divider>
              <editor ref="editor" v-model="data.InfoContent"></editor>
              <el-input v-model="data.InfoContent" v-show="false"></el-input>
            </el-form-item>
          </el-col>
         
          <el-col :span="24">
            <el-form-item label="附件" class="file-text">
              <div style="position:relative;">
                <el-tooltip style="position: absolute;left: 25px;top: 7px;" effect="light" v-if="$store.state.user.attSize > 0"
                  :content="'附件大小不超过' + $store.state.user.attSize +'MB。'" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-upload
                  :action="host + '/api/Common/UploadFile'"
                  list-type="text"
                  :data="{ dic:'InfoDetail' }"
                  :show-file-list="true"
                  :on-success="onSuccess"
                  accept=".pdf,.txt,.docx,.xlsx,"
                  :headers="headers"
                  :file-list="fl"
                  :limit="1"
                  :on-preview="dlfile"
                  :on-exceed="onExceed"
                  :before-upload="beforeFileUpload"
                  :on-remove="attachRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave(0)">保 存</el-button>
      
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import editor from '@/components/common/editor.vue';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    editor,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        InfoTitle:"",
        InfoTypeId: null,
        InfoSource: "",
        InfoLink: "",
        InfoContent: "",
        InfoContentText: "",
        InfoBrief: "",
        IfTop: 1,
        PhotoAddress: "",
        ReleaseTime: "",
        InfoAttach: "",
        State: 0,
      },
      fl: [],
      list: [],
      saveState: 0,
      headers: { Authorization: "" },
    
      isMB: this.$store.state.isMB,
      rules: {
        InfoTitle:[{ required: true, message: "文章标题不能为空" }],
        InfoContent: [{ required: true, message: "文章内容不能为空" }],
     
        InfoTypeId: [{ required: true, message: "文章类别不能为空" }],
        ReleaseTime: [{ required: true, message: "发布日期不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl:"/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
    
    },
    onEditOpened(data) {
    
    },
    getOption() {
     
    },
    beforeFileUpload(file) {
     
    },
    onSuccess(res,file) {
     
    },
    dlfile(file) {
      
    },
    onExceed() {
     
    },
    attachRemove(file) {
     
    },
    toSave(t) {
     
    },
    onBeforeSave() {
      
    },
    getIntro() {
    
    },
    // checkInt(name) {
    //   if(!(this.data[name] >= 0)) {
    //     this.data[name] = 0;
    //   } else if(this.data[name] %1 != 0) {
    //     this.data[name] = Math.floor(this.data[name]);
    //   }
    // },
    onClosed() {
      
    },
  }
};
</script>
<style lang="scss" scoped>
.file-text{
  .el-form-item__label {
    line-height: 28px;
  }
}
</style>